<div *ngFor="let item of items" [ngSwitch]="item.Content">   

    <!-- <app-notification *ngSwitchCase="'#candidatedecide'" [badge]="" ctaLabel="Zum Profil" (click)="navigateToCandidate(item.Candidate)">
        Bitte schaue dir das Profil von {{ item.Candidate.FirstName }} {{ item.Candidate.LastName }} an.
    </app-notification>

    <app-notification *ngSwitchCase="'#candidatestatus'" [badge]="" ctaLabel="Zum Profil" (click)="navigateToCandidate(item.Candidate)">
        Bitte geben Sie ein Statusupdate zu {{ item.Candidate.FirstName }} {{ item.Candidate.LastName }}.
    </app-notification>

    <app-notification *ngSwitchCase="'#candidatefeedback'" [badge]="" ctaLabel="Zum Profil" (click)="navigateToCandidate(item.Candidate)">
        Bitte geben Sie eine Einschätzung zu {{ item.Candidate.FirstName }} {{ item.Candidate.LastName }}.
    </app-notification> -->

    <app-notification *ngSwitchCase="'#projectreviewjobsite'" [badge]="" [ctaLabel]="texts.reviewJobsiteCta[language]" (click)="launchJobsiteReview()">
        {{ texts.reviewJobsite[language] }}
    </app-notification>

    <app-notification *ngSwitchCase="'#projectfeedbackjobsite'" [badge]="" [ctaLabel]="texts.feedbackJobsiteCta[language]" (click)="launchJobsiteReview()">
        {{ texts.feedbackJobsite[language] }}
    </app-notification>

</div>